import { classNames } from "../../shared/utility";

export default function SetupTabs({ tabs, value, onChange, className = "" }) {
  const activeIndex = tabs.findIndex((tab) => tab.id === value);

  return (
    <div className={className}>
      <div className="sm:hidden">
        <label htmlFor="setup-tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="setup-tabs"
          name="setup-tabs"
          className="block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2 text-sm shadow-sm"
          value={value}
          onChange={(event) => onChange(event.target.value)}
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav
          className="flex rounded-xl border border-[#E2E8F0] bg-[#F6F8FB] p-1"
          aria-label="Tabs"
        >
          {tabs.map((tab, index) => (
            <button
              key={tab.id}
              type="button"
              className={classNames(
                index === activeIndex
                  ? "bg-white text-[#2563EB] shadow-sm ring-1 ring-[#E2E8F0]"
                  : "text-[#64748B] hover:bg-white hover:text-[#0F172A]",
                "flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition",
              )}
              aria-current={index === activeIndex ? "page" : undefined}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
